import * as React from 'react';
import SidebarLink from 'src/modules/Routing/Sidebar/SidebarLink/SidebarLink';
import { useAuth } from 'src/modules/Auth/hooks/useAuth';
import Routes from 'src/modules/Routing/routes';
import { useRoutes } from 'src/modules/Routing/hooks/routes/useRoutes';

const NotificationSidebarLinks = () => {
  const [auth] = useAuth();
  const [routes] = useRoutes();
  return (
    <>
      <SidebarLink userType={auth.userType} routes={routes} to={Routes.ADD} label={'Add new case'} />
      <SidebarLink userType={auth.userType} routes={routes} to={Routes.ADDALERT} label={'Add new alert'} />
    </>
  )
}

export default NotificationSidebarLinks;
